import BrandSVG from '../../assets/brand.svg?react'

const Brand = ({ width, height, onClick }) => {
  return (
    <div
      style={{ cursor: 'pointer' }}
      onClick={onClick}
    >
      <BrandSVG style={{ width, height }} />
    </div>
  )
}

export default Brand
